var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// ./~/enquire.js/src/index.js
// module id = 754
// module chunks = 168707334958949